import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router)

let router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/candidate',
          name: 'candidate',
          component: () => import(/* webpackChunkName: "demo" */ './views/Candidate.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/employer',
          name: 'employer',
          component: () => import(/* webpackChunkName: "demo" */ './views/Employer.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/articles',
          name: 'articles',
          component: () => import(/* webpackChunkName: "demo" */ './views/Articles.vue'),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: '/icons',
        //   name: 'icons',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue'),
        //   meta : {
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: '/profile',
        //   name: 'profile',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
        //   meta : {
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: '/maps',
        //   name: 'maps',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue'),
        //   meta : {
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: '/tables',
        //   name: 'tables',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue'),
        //   meta : {
        //     requiresAuth: true
        //   }
        // },
        {
          path: '/credit-packages',
          name: 'credit package',
          component: () => import('./views/CreditPackages.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/job-applications',
          name: 'job applications',
          component: () => import('./views/JobApplications.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/find-talents',
          name: 'find talents',
          component: () => import('./views/FindTalents.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/selections',
          name: 'selections',
          component: () => import('./views/Selections.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/push-notifications',
          name: 'announcements',
          component: () => import('./views/PushNotifications.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/employer-static-contents',
          name: 'employer static contents',
          component: () => import('./views/EmployerStaticContents.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/candidate-static-contents',
          name: 'candidate static contents',
          component: () => import('./views/CandidateStaticContents.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/app-versions',
          name: 'app versions',
          component: () => import('./views/AppVersions.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue'),
          meta: {
            guest: true
          }
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue'),
          meta: {
            guest: true
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        console.log(localStorage.getItem('access_token'));
        if (localStorage.getItem('access_token') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            // let user = JSON.parse(localStorage.getItem('user'))
            // if(to.matched.some(record => record.meta.is_admin)) {
            //     if(user.is_admin == 1){
            //         next()
            //     }
            //     else{
            //         next({ name: 'userboard'})
            //     }
            // }else {
                next()
            // }
        }
    } else if(to.matched.some(record => record.meta.guest)) {
        if(localStorage.getItem('access_token') == null){
            next()
        }
        else{
            next()
        }
    }else {
        next() 
    }
})

export default router
